export default __webpack_public_path__ + "static/img-art-pandas-profiling-1-3d0ee8b167d2dfe554abfc16995bf3d9.png";